import React from 'react';
import { createContext } from 'react';
import { authenticationUseCase, IAuthenticationUseCase } from '@/domains/auth/useCases/AuthenticationUseCase';
import {getPersonAdapter, IPersonAdapter} from '@/domains/auth/adapters/PersonAdapter';

const createDependencies = () => ({
    authenticationUseCase: authenticationUseCase,
    personAdapter: getPersonAdapter(),
})


interface ContextValue {
   authenticationUseCase: IAuthenticationUseCase;
   personAdapter: IPersonAdapter;
}

const ApplicationContext = createContext<ContextValue>({} as ContextValue);
const useApplication = (): ContextValue => {
  return React.useContext(ApplicationContext);
};
interface Props {
  children: React.ReactNode;
  dependencies: {
    authenticationUseCase: IAuthenticationUseCase;
    personAdapter: IPersonAdapter;
  };
}
const ApplicationProvider = ({ children, dependencies }: Props) => {
  return (
    <ApplicationContext.Provider
      value={{
        authenticationUseCase: dependencies.authenticationUseCase,
        personAdapter: dependencies.personAdapter,
      }}
    >
      {children}
    </ApplicationContext.Provider>
  );
};

export { ApplicationProvider, useApplication, createDependencies };